var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 38,
    viewBox: "0 0 21 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6780_25189",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-0.83205 0.5547 0 1 20.7812 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6780_25189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2913 25.0267V22.3267L18.41 19.5809C18.7012 19.3867 18.9196 19.087 19.0652 18.6816C19.2108 18.2762 19.2074 17.9743 19.0548 17.776L16.6003 14.7874C16.8637 14.6117 17.0579 14.3489 17.1827 13.9991C17.3075 13.6492 17.3006 13.3872 17.1619 13.2129L13.4385 8.52022C13.2859 8.33858 13.071 8.34021 12.7936 8.52511C12.5163 8.71001 12.3013 8.99498 12.1488 9.38001L10.7967 12.9064L9.44463 11.1828C9.29208 11.0011 9.07714 11.0028 8.79979 11.1877C8.52244 11.3726 8.30749 11.6575 8.15495 12.0426L4.43152 21.6999C4.29285 22.059 4.28591 22.3303 4.41072 22.5137C4.53553 22.6972 4.72967 22.7011 4.99316 22.5254L2.53861 28.7868C2.38606 29.1885 2.3826 29.495 2.52821 29.7062C2.67382 29.9175 2.89223 29.926 3.18345 29.7319L7.3021 26.9861V29.6861C7.3021 29.9361 7.3749 30.1001 7.52051 30.178C7.66612 30.256 7.84293 30.2256 8.05094 30.0869L9.54863 29.0884C9.75664 28.9498 9.93346 28.7444 10.0791 28.4723C10.2247 28.2003 10.2975 27.9392 10.2975 27.6892V24.9892L11.2959 24.3236V27.0236C11.2959 27.2736 11.3687 27.4375 11.5144 27.5155C11.66 27.5934 11.8368 27.563 12.0448 27.4243L13.5425 26.4259C13.7505 26.2872 13.9273 26.0818 14.0729 25.8098C14.2185 25.5377 14.2913 25.2767 14.2913 25.0267ZM6.76126 25.5467L4.55633 27.0166L7.71812 18.9088L6.51165 19.7131L8.79979 13.7877L9.92305 15.1888L8.42536 19.0373C8.28669 19.3964 8.27975 19.6677 8.40456 19.8512C8.52937 20.0346 8.72352 20.0385 8.987 19.8629L6.76126 25.5467ZM17.0579 18.6823L8.52937 24.368L11.712 16.2462L10.5055 17.0505L12.7936 11.1251L15.0818 13.9997L13.8753 14.804L17.0579 18.6823ZM17.0579 18.6823L14.1457 20.6237L15.3938 19.7917L10.6719 22.9396L11.92 22.1075L8.52937 24.368L17.0579 18.6823ZM6.76126 25.5467L9.17421 23.9381L7.3021 25.1861L9.86065 23.4804L6.17883 25.935L6.76126 25.5467Z",
    fill: "#FF0F64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegna);
export default __webpack_public_path__ + "static/media/legna.feac4bcdc11f54627e6c7df043477da5.svg";
export { ForwardRef as ReactComponent };